export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20stylish%20white%20leather%20sneakers%20placed%20diagonally%20on%20white%20marble%20surface%20with%20subtle%20grey%20veining%20bright%20studio%20lighting%20casting%20crisp%20shadows%20modern%20minimal%20product%20photography%20high%20contrast%20clean%20aesthetic%20no%20text&width=400&height=400&seq=cat-shoes-v3&orientation=squarish',
  },
  {
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20cozy%20knitted%20sweaters%20in%20pastel%20tones%20neatly%20stacked%20vertically%20on%20light%20linen%20textured%20surface%20warm%20golden%20hour%20sunlight%20streaming%20from%20left%20side%20editorial%20fashion%20flatlay%20soft%20shadows%20relaxed%20aesthetic&width=400&height=400&seq=cat-hoodies-v3&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Five%20solid%20color%20cotton%20tshirts%20hanging%20evenly%20spaced%20on%20a%20minimalist%20wooden%20clothes%20rack%20against%20off%20white%20wall%20with%20trailing%20green%20plant%20on%20right%20side%20airy%20bright%20room%20natural%20daylight%20contemporary%20product%20display&width=400&height=400&seq=cat-tshirts-v3&orientation=squarish',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20premium%20denim%20jacket%20draped%20casually%20over%20a%20mid%20century%20modern%20wooden%20chair%20placed%20near%20a%20sunlit%20window%20with%20sheer%20white%20curtains%20soft%20morning%20light%20creating%20gentle%20shadows%20lifestyle%20product%20photography%20editorial%20quality&width=400&height=400&seq=cat-jackets-v3&orientation=squarish',
  },
  {
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20tailored%20trousers%20one%20beige%20one%20charcoal%20grey%20folded%20with%20precision%20on%20light%20oak%20wood%20flooring%20surface%20diffused%20overhead%20studio%20lighting%20sharp%20clean%20lines%20fashion%20catalog%20style%20no%20text&width=400&height=400&seq=cat-pants-v3&orientation=squarish',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20baseball%20caps%20in%20neutral%20colors%20displayed%20on%20floating%20white%20shelves%20against%20warm%20sand%20colored%20wall%20with%20soft%20spotlight%20illumination%20gallery%20style%20display%20minimal%20aesthetic%20clean%20composition%20no%20text&width=400&height=400&seq=cat-headwear-v3&orientation=squarish',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20two%20piece%20casual%20outfit%20set%20flatlay%20top%20down%20view%20on%20light%20sage%20green%20textured%20backdrop%20with%20delicate%20dried%20flowers%20scattered%20around%20edges%20bright%20even%20daylight%20editorial%20product%20styling%20harmonious%20composition&width=400&height=400&seq=cat-sets-v3&orientation=squarish',
  },
  {
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20essentials%20neatly%20arranged%20in%20a%20grid%20pattern%20on%20crisp%20white%20ceramic%20surface%20soft%20diffused%20studio%20lighting%20highlighting%20fabric%20texture%20clean%20modern%20intimate%20apparel%20photography%20no%20text&width=400&height=400&seq=cat-underwear-v3&orientation=squarish',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Basketball%20jersey%20displayed%20flat%20on%20dark%20polished%20concrete%20floor%20with%20dramatic%20side%20lighting%20creating%20strong%20shadows%20sports%20editorial%20photography%20bold%20composition%20athletic%20aesthetic%20urban%20mood%20no%20text&width=400&height=400&seq=cat-jersey-v3&orientation=squarish',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20wristwatch%20leather%20bracelet%20and%20minimalist%20gold%20ring%20artfully%20scattered%20on%20soft%20suede%20surface%20warm%20tungsten%20lighting%20casting%20gentle%20glow%20luxury%20accessory%20editorial%20photography%20rich%20textures%20sophisticated%20composition&width=400&height=400&seq=cat-accessories-v3&orientation=squarish',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20tote%20bag%20and%20crossbody%20bag%20placed%20on%20light%20grey%20stone%20floor%20tiles%20near%20white%20wall%20with%20soft%20natural%20light%20from%20above%20minimal%20everyday%20carry%20fashion%20product%20photography%20clean%20composition%20airy%20atmosphere&width=400&height=400&seq=cat-bags-v3&orientation=squarish',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genuine%20leather%20belts%20in%20brown%20and%20tan%20tones%20rolled%20elegantly%20on%20dark%20walnut%20wood%20surface%20with%20subtle%20warm%20backlight%20creating%20rich%20highlights%20craftsmanship%20product%20photography%20tactile%20quality%20no%20text&width=400&height=400&seq=cat-belts-v3&orientation=squarish',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20designer%20perfume%20bottles%20of%20varying%20heights%20arranged%20on%20reflective%20black%20glass%20surface%20with%20dramatic%20soft%20rim%20lighting%20creating%20elegant%20reflections%20luxury%20fragrance%20product%20photography%20moody%20sophisticated%20composition&width=400&height=400&seq=cat-perfumes-v3&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20accessories%20including%20sunglasses%20keychain%20and%20small%20leather%20goods%20displayed%20on%20natural%20rattan%20surface%20with%20warm%20afternoon%20sunlight%20creating%20dappled%20shadows%20casual%20curated%20product%20photography%20relaxed%20vibe&width=400&height=400&seq=cat-other-v3&orientation=squarish',
  },
];

export const trustBadges = [
  { icon: 'ri-refresh-line', text: 'Updated Regularly' },
  { icon: 'ri-stack-line', text: 'Organized Categories' },
  { icon: 'ri-user-smile-line', text: 'Beginner Friendly' },
  { icon: 'ri-book-open-line', text: 'Complete Guide' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';